import React, { useState } from 'react';
import { CountdownTimer } from '../components/CountdownTimer';
import { TestimonialCarousel } from '../components/TestimonialCarousel';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { CheckCircle2, ChevronRight, Clock, ShieldCheck, Download, Smartphone, Check, PlaneTakeoff, Brain, HeartHandshake, Headphones, BookOpen, FileText, ListChecks } from 'lucide-react';
const IMAGES = {
  logo: 'https://cdn.magicpatterns.com/uploads/gunxqmX3DLE3VayEChcB9z/LOGO_ATLAS.png',
  aerofobia: 'https://cdn.magicpatterns.com/uploads/1mVdpFchd5giBM25U8BsiK/AEROFOBIA.png',
  checklist: 'https://cdn.magicpatterns.com/uploads/wDAogEQctEEugt1Ckfp8e1/CHECKLIST.png',
  cuaderno: 'https://cdn.magicpatterns.com/uploads/8TaniZ9QhgVHdEYDseeY6z/Cuaderno_de_ejercicios.png',
  guiaSos: 'https://cdn.magicpatterns.com/uploads/eGWxKbZFeAThtG1LpDP8Pk/GUIA_SOS.png',
  biblioteca: 'https://cdn.magicpatterns.com/uploads/7NE7uCYZUcEmekCjGdKWyc/BIBLIOTECA_DE_CALMA_EN_VUELO.png'
};
const FAQS = [{
  q: '¿Esto elimina el miedo a volar?',
  a: 'No prometemos eliminar el miedo de un día para el otro. Te da herramientas prácticas para entenderlo, regular la ansiedad y atravesar el vuelo con más calma.'
}, {
  q: '¿Cuándo recibo el acceso?',
  a: 'El acceso es inmediato. Podés empezar a leer, escuchar y completar los ejercicios apenas recibís el material.'
}, {
  q: '¿Puedo usarlo durante el vuelo?',
  a: 'Sí. La Guía SOS está pensada para leer en el avión y los audios pueden escucharse con auriculares sin conexión (si los descargás antes).'
}, {
  q: '¿Los audios necesitan internet?',
  a: 'Recomendamos descargarlos antes del viaje para poder escucharlos incluso si no tenés conexión durante el vuelo.'
}, {
  q: '¿Es un tratamiento psicológico?',
  a: 'No. Es un recurso educativo y de acompañamiento. No reemplaza atención médica ni tratamiento psicológico profesional.'
}];
const CART_URL = 'https://pago.atlasdigitalhub.com/cart/43052128108642:1';
export function Landing() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const scrollToBuy = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const buyNow = () => {
    window.location.href = CART_URL;
  };
  return <div className="min-h-screen bg-polar font-sans text-oceano" data-id="element-33">
      <SocialProofPopup data-id="element-34" />

      {/* SECCIÓN 1 — Barra superior */}
      <div className="fixed top-0 left-0 right-0 z-50" data-id="element-35">
        <div className="bg-oceano text-polar text-[10px] md:text-sm py-1.5 md:py-2 text-center font-medium tracking-wide" data-id="element-36">
          Producto 100% digital · Acceso inmediato
        </div>
        <div className="bg-travertino text-oceano text-xs md:text-sm py-2 text-center font-medium flex items-center justify-center gap-2 shadow-sm" data-id="element-37">
          <Clock size={16} className="text-oceano" data-id="element-38" />
          <span data-id="element-39">Oferta por tiempo limitado · termina en:</span>
          <CountdownTimer initialMinutes={20} data-id="element-40" />
        </div>
      </div>

      {/* HERO MOBILE-FIRST: logo → título/subtítulo → imagen → texto */}
      <section className="pt-28 pb-12 md:pt-40 md:pb-20 px-4 max-w-3xl mx-auto flex flex-col items-center text-center space-y-6 md:space-y-8" data-id="element-41">
        {/* 1. Logo */}
        <img src={IMAGES.logo} alt="Atlas de Viajes" className="h-24 md:h-32 object-contain" data-id="element-42" />

        {/* 2. Título y subtítulo */}
        <div data-id="element-43">
          <h1 className="font-cormorant text-4xl md:text-6xl lg:text-7xl font-semibold leading-tight mb-4" data-id="element-44">
            No dejes que el <span className="text-caribe" data-id="element-45">miedo</span> decida tu
            próximo viaje
          </h1>
          <p className="text-lg md:text-2xl text-hierro font-medium leading-snug" data-id="element-46">
            Un método práctico para calmar la ansiedad, entender lo que pasa en
            el avión y vivir tu próximo vuelo con más tranquilidad.
          </p>
        </div>

        {/* 3. Imagen */}
        <div className="w-full max-w-sm mx-auto relative mt-2" data-id="element-47">
          <div className="absolute -top-4 -right-4 w-28 h-28 bg-travertino/20 rounded-full blur-2xl" data-id="element-48"></div>
          <div className="absolute -bottom-4 -left-4 w-28 h-28 bg-caribe/20 rounded-full blur-2xl" data-id="element-49"></div>
          <img src={IMAGES.aerofobia} alt="Mockup Aerofobia" className="relative z-10 w-full h-auto rounded-2xl shadow-xl object-contain" data-id="element-50" />
        </div>

        {/* 4. Texto y todo */}

        <ul className="space-y-3 w-full max-w-md text-left" data-id="element-51">
          {['Para ansiedad antes del vuelo.', 'Para miedo a turbulencias y ruidos.', 'Para usar en el aeropuerto y en el avión.', 'Incluye guía, audios, ejercicios y checklist.'].map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-52">
              <CheckCircle2 className="text-caribe shrink-0 mt-0.5" size={20} data-id="element-53" />
              <span className="text-oceano font-medium" data-id="element-54">{bullet}</span>
            </li>)}
        </ul>

        <div className="w-full max-w-md pt-2" data-id="element-55">
          <button onClick={scrollToBuy} className="w-full bg-caribe hover:bg-[#24a8a2] text-polar px-8 py-4 md:px-10 md:py-5 rounded-xl font-semibold text-lg md:text-xl transition-colors shadow-lg shadow-caribe/20 flex items-center justify-center gap-2" data-id="element-56">
            Quiero volar con más calma
          </button>
          <p className="text-xs md:text-sm text-hierro flex items-center justify-center gap-2 mt-4" data-id="element-57">
            Acceso inmediato · Producto digital
          </p>
        </div>
      </section>

      {/* SECCIÓN DE DOLOR MÁS HUMANA */}
      <section className="bg-oceano text-polar py-16 md:py-20 px-4" data-id="element-58">
        <div className="max-w-4xl mx-auto" data-id="element-59">
          <h2 className="font-cormorant text-3xl md:text-5xl font-semibold mb-6 text-center md:text-left" data-id="element-60">
            ¿Sentís que el miedo empieza mucho antes del vuelo?
          </h2>
          

          <div className="grid sm:grid-cols-2 gap-4 mb-12" data-id="element-61">
            {['Te cuesta dormir la noche anterior.', 'Pensás "¿y si me agarra ansiedad en el avión?"', 'Cada ruido te hace imaginar lo peor.', 'La turbulencia te activa el cuerpo.', 'Sentís que no tener control es lo más difícil.', 'Querés viajar, pero el miedo te frena.'].map((q, i) => <div key={i} className="bg-polar/5 p-5 rounded-xl border border-polar/10 flex items-start gap-3" data-id="element-62">
                <div className="w-1.5 h-1.5 rounded-full bg-travertino mt-2 shrink-0" data-id="element-63"></div>
                <p className="text-polar/90 font-medium" data-id="element-64">{q}</p>
              </div>)}
          </div>

          <div className="bg-travertino/10 border border-travertino/20 p-6 rounded-2xl text-center mb-8" data-id="element-65">
            <p className="font-cormorant text-2xl md:text-3xl text-travertino italic" data-id="element-66">
              "El problema no es que no quieras viajar. Es que no querés volver
              a sufrir todo el vuelo."
            </p>
          </div>

          <p className="text-center text-polar/90 text-lg" data-id="element-67">
            Por eso este método no te habla desde la teoría. Te da herramientas
            simples para saber qué hacer cuando el miedo aparece.
          </p>
        </div>
      </section>

      {/* SECCIÓN PUENTE / NUEVA CREENCIA */}
      <section className="py-16 md:py-20 px-4 bg-polar" data-id="element-68">
        <div className="max-w-5xl mx-auto text-center" data-id="element-69">
          <h2 className="font-cormorant text-3xl md:text-5xl font-semibold text-oceano mb-6" data-id="element-70">
            No necesitás controlar el avión. Necesitás un plan para tu ansiedad.
          </h2>
          <p className="text-lg md:text-xl text-hierro mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-71">
            Cuando entendés qué pasa en tu cuerpo, qué cosas son normales
            durante el vuelo y qué hacer en los momentos difíciles, el miedo
            deja de sentirse tan gigante.
          </p>

          <p className="font-semibold text-oceano text-xl mb-8" data-id="element-72">
            El Método Volar en Calma trabaja en 3 pasos:
          </p>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-73">
            {[{
            title: 'Entender',
            desc: 'Qué es la aerofobia, por qué aparece la ansiedad y qué significan muchas sensaciones del vuelo.',
            icon: <Brain className="text-caribe" size={32} data-id="element-74" />
          }, {
            title: 'Preparar',
            desc: 'Ejercicios, checklist y recursos para llegar al aeropuerto con más claridad.',
            icon: <PlaneTakeoff className="text-caribe" size={32} data-id="element-75" />
          }, {
            title: 'Acompañar',
            desc: 'Guía SOS, audios y meditaciones para usar antes y durante el vuelo.',
            icon: <HeartHandshake className="text-caribe" size={32} data-id="element-76" />
          }].map((pillar, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-sm border border-travertino/20 text-center flex flex-col items-center" data-id="element-77">
                <div className="w-16 h-16 bg-caribe/10 rounded-full flex items-center justify-center mb-4" data-id="element-78">
                  {pillar.icon}
                </div>
                <h3 className="font-cormorant text-2xl font-semibold text-oceano mb-3" data-id="element-79">
                  {pillar.title}
                </h3>
                <p className="text-hierro text-sm leading-relaxed" data-id="element-80">
                  {pillar.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* QUÉ INCLUYE EL MÉTODO */}
      <section className="py-16 md:py-20 px-4 bg-[#F5F5F0]" data-id="element-81">
        <div className="max-w-6xl mx-auto" data-id="element-82">
          <div className="text-center mb-12" data-id="element-83">
            <h2 className="font-cormorant text-4xl md:text-5xl font-semibold text-oceano mb-4" data-id="element-84">
              ¿Qué incluye el método?
            </h2>
          </div>

          <div className="flex flex-col gap-8 md:grid md:grid-cols-2 lg:grid-cols-3" data-id="element-85">
            {/* Card 1 */}
            <div className="bg-white rounded-3xl overflow-hidden border border-travertino/20 shadow-sm flex flex-col" data-id="element-86">
              <div className="p-6 bg-polar flex justify-center items-center h-64 md:h-72" data-id="element-87">
                <img src={IMAGES.aerofobia} alt="Ebook" className="max-w-full max-h-full object-contain drop-shadow-xl" data-id="element-88" />
              </div>
              <div className="p-6 md:p-8 flex-1 border-t border-travertino/10" data-id="element-89">
                <div className="flex items-center gap-2 mb-3" data-id="element-90">
                  <BookOpen size={18} className="text-caribe" data-id="element-91" />
                  <span className="text-xs font-bold text-caribe uppercase tracking-wider" data-id="element-92">
                    Ebook principal
                  </span>
                </div>
                <h3 className="font-cormorant text-2xl font-semibold text-oceano mb-2" data-id="element-93">
                  Aerofobia: Guía para Volar en Calma
                </h3>
                <p className="text-hierro text-sm leading-relaxed" data-id="element-94">
                  La guía base para entender el miedo, conocer qué pasa en el
                  avión y aprender herramientas para viajar con más
                  tranquilidad.
                </p>
              </div>
            </div>

            {/* Card 2 */}
            <div className="bg-white rounded-3xl overflow-hidden border border-travertino/20 shadow-sm flex flex-col" data-id="element-95">
              <div className="p-6 bg-polar flex justify-center items-center h-64 md:h-72" data-id="element-96">
                <img src={IMAGES.guiaSos} alt="Guía SOS" className="max-w-full max-h-full object-contain drop-shadow-xl" data-id="element-97" />
              </div>
              <div className="p-6 md:p-8 flex-1 border-t border-travertino/10" data-id="element-98">
                <div className="flex items-center gap-2 mb-3" data-id="element-99">
                  <Smartphone size={18} className="text-caribe" data-id="element-100" />
                  <span className="text-xs font-bold text-caribe uppercase tracking-wider" data-id="element-101">
                    Recurso rápido
                  </span>
                </div>
                <h3 className="font-cormorant text-2xl font-semibold text-oceano mb-2" data-id="element-102">
                  Guía SOS para leer en el avión
                </h3>
                <p className="text-hierro text-sm leading-relaxed" data-id="element-103">
                  Un recurso rápido para abrir desde el celular cuando aparece
                  ansiedad, turbulencia, miedo al despegue o sensación de
                  pérdida de control.
                </p>
              </div>
            </div>

            {/* Card 3 */}
            <div className="bg-white rounded-3xl overflow-hidden border border-travertino/20 shadow-sm flex flex-col" data-id="element-104">
              <div className="p-6 bg-polar flex justify-center items-center h-64 md:h-72" data-id="element-105">
                <img src={IMAGES.biblioteca} alt="Biblioteca de Calma en Vuelo" className="max-w-full max-h-full object-contain drop-shadow-xl rounded-xl" data-id="element-106" />
              </div>
              <div className="p-6 md:p-8 flex-1 border-t border-travertino/10" data-id="element-107">
                <div className="flex items-center gap-2 mb-3" data-id="element-108">
                  <Headphones size={18} className="text-caribe" data-id="element-109" />
                  <span className="text-xs font-bold text-caribe uppercase tracking-wider" data-id="element-110">
                    Audio
                  </span>
                </div>
                <h3 className="font-cormorant text-2xl font-semibold text-oceano mb-2" data-id="element-111">
                  Biblioteca de Calma en Vuelo
                </h3>
                <p className="text-hierro text-sm leading-relaxed" data-id="element-112">
                  Incluye audios de soporte, meditaciones guiadas y podcasts
                  explicativos para acompañarte antes y durante el vuelo.
                </p>
              </div>
            </div>

            {/* Card 4 */}
            <div className="bg-white rounded-3xl overflow-hidden border border-travertino/20 shadow-sm flex flex-col md:col-start-1 lg:col-start-2" data-id="element-113">
              <div className="p-6 bg-polar flex justify-center items-center h-64 md:h-72" data-id="element-114">
                <img src={IMAGES.cuaderno} alt="Cuaderno" className="max-w-full max-h-full object-contain drop-shadow-xl" data-id="element-115" />
              </div>
              <div className="p-6 md:p-8 flex-1 border-t border-travertino/10" data-id="element-116">
                <div className="flex items-center gap-2 mb-3" data-id="element-117">
                  <FileText size={18} className="text-caribe" data-id="element-118" />
                  <span className="text-xs font-bold text-caribe uppercase tracking-wider" data-id="element-119">
                    Imprimible
                  </span>
                </div>
                <h3 className="font-cormorant text-2xl font-semibold text-oceano mb-2" data-id="element-120">
                  Cuaderno de ejercicios imprimible +30 páginas
                </h3>
                <p className="text-hierro text-sm leading-relaxed" data-id="element-121">
                  Ejercicios para ordenar tus pensamientos, identificar miedos,
                  preparar tu plan de calma y registrar tu avance.
                </p>
              </div>
            </div>

            {/* Card 5 */}
            <div className="bg-white rounded-3xl overflow-hidden border border-travertino/20 shadow-sm flex flex-col" data-id="element-122">
              <div className="p-6 bg-polar flex justify-center items-center h-64 md:h-72" data-id="element-123">
                <img src={IMAGES.checklist} alt="Checklist" className="max-w-full max-h-full object-contain drop-shadow-xl" data-id="element-124" />
              </div>
              <div className="p-6 md:p-8 flex-1 border-t border-travertino/10" data-id="element-125">
                <div className="flex items-center gap-2 mb-3" data-id="element-126">
                  <ListChecks size={18} className="text-caribe" data-id="element-127" />
                  <span className="text-xs font-bold text-caribe uppercase tracking-wider" data-id="element-128">
                    Organización
                  </span>
                </div>
                <h3 className="font-cormorant text-2xl font-semibold text-oceano mb-2" data-id="element-129">
                  Checklist pre-vuelo antiansiedad
                </h3>
                <p className="text-hierro text-sm leading-relaxed" data-id="element-130">
                  Una lista práctica para preparar documentos, objetos de calma,
                  audios, respiraciones y todo lo necesario antes de subir al
                  avión.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN “CUÁNDO USARLO” */}
      <section className="py-16 md:py-20 px-4 bg-polar" data-id="element-131">
        <div className="max-w-4xl mx-auto" data-id="element-132">
          <h2 className="font-cormorant text-3xl md:text-5xl font-semibold text-oceano text-center mb-12" data-id="element-133">
            Usalo justo cuando más lo necesitás
          </h2>

          <div className="space-y-6 relative before:absolute before:inset-0 before:ml-6 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-travertino/30" data-id="element-134">
            {[{
            title: 'Antes del viaje',
            desc: 'Para ansiedad anticipatoria, pensamientos repetitivos y miedo antes de dormir.'
          }, {
            title: 'En el aeropuerto',
            desc: 'Para bajar nervios, ordenar la mente y no entrar al avión en alerta total.'
          }, {
            title: 'Durante el despegue',
            desc: 'Para respirar, entender los ruidos y atravesar los primeros minutos.'
          }, {
            title: 'En turbulencia',
            desc: 'Para recordar qué hacer, escuchar audios y evitar entrar en pánico.'
          }, {
            title: 'En pleno vuelo',
            desc: 'Para volver al presente cuando aparece sensación de encierro o pérdida de control.'
          }].map((item, i) => <div key={i} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-135">
                <div className="flex items-center justify-center w-12 h-12 rounded-full border-4 border-polar bg-caribe text-polar shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-sm z-10" data-id="element-136">
                  <Check size={20} data-id="element-137" />
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] bg-white p-5 rounded-2xl shadow-sm border border-travertino/20" data-id="element-138">
                  <h3 className="font-cormorant text-xl font-semibold text-oceano mb-1" data-id="element-139">
                    {item.title}
                  </h3>
                  <p className="text-hierro text-sm leading-relaxed" data-id="element-140">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* BENEFICIOS */}
      <section className="py-16 md:py-20 px-4 bg-oceano text-polar" data-id="element-141">
        <div className="max-w-4xl mx-auto" data-id="element-142">
          <h2 className="font-cormorant text-3xl md:text-5xl font-semibold text-center mb-10" data-id="element-143">
            Con este método vas a poder…
          </h2>

          <div className="grid sm:grid-cols-2 gap-x-8 gap-y-4 mb-12" data-id="element-144">
            {['Llegar al vuelo con un plan, no solo con miedo.', 'Entender sensaciones que antes te asustaban.', 'Tener una guía para leer en el avión.', 'Escuchar audios cuando necesitás calma.', 'Prepararte emocionalmente antes de viajar.', 'Sentirte más acompañada/o durante el vuelo.'].map((benefit, i) => <div key={i} className="flex items-start gap-3 bg-polar/5 p-4 rounded-xl border border-polar/10" data-id="element-145">
                <CheckCircle2 className="text-caribe shrink-0 mt-0.5" size={20} data-id="element-146" />
                <span className="text-polar/90 font-medium" data-id="element-147">{benefit}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-148">
            <p className="font-cormorant text-2xl md:text-3xl text-travertino italic" data-id="element-149">
              "No prometemos magia. Te damos algo más útil: herramientas
              concretas para atravesar el miedo."
            </p>
          </div>
        </div>
      </section>

      {/* TESTIMONIOS */}
      <section className="py-16 md:py-20 px-4 bg-[#F5F5F0] overflow-hidden" data-id="element-150">
        <div className="max-w-6xl mx-auto" data-id="element-151">
          <div className="text-center mb-12" data-id="element-152">
            <h2 className="font-cormorant text-3xl md:text-5xl font-semibold text-oceano mb-4" data-id="element-153">
              Personas que empezaron a viajar con más calma
            </h2>
          </div>

          <TestimonialCarousel data-id="element-154" />
        </div>
      </section>

      {/* SECCIÓN DE COMPRA */}
      <section id="compra" className="py-16 md:py-24 px-4 bg-oceano relative" data-id="element-155">
        <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')]" data-id="element-156"></div>

        <div className="max-w-5xl mx-auto relative z-10" data-id="element-157">
          <div className="text-center mb-10" data-id="element-158">
            <h2 className="font-cormorant text-4xl md:text-5xl lg:text-6xl font-semibold text-polar mb-4" data-id="element-159">
              Accedé hoy al Método Volar en Calma
            </h2>
          </div>

          <div className="bg-polar rounded-3xl p-6 md:p-12 shadow-2xl max-w-3xl mx-auto" data-id="element-160">
            {/* 1. Todo lo que incluye (primero y llamativo) */}
            <div className="mb-10" data-id="element-161">
              <h3 className="font-cormorant text-2xl md:text-3xl font-semibold text-oceano mb-6 text-center" data-id="element-162">
                Todo lo que incluye el método
              </h3>
              <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-3" data-id="element-163">
                {['Ebook principal Aerofobia: Guía para Volar en Calma', 'Guía SOS para leer en el avión', 'Audios de soporte para momentos de ansiedad', 'Meditaciones guiadas para viajar con calma', 'Podcasts explicativos para entender el miedo a volar', 'Cuaderno de ejercicios imprimible +30 páginas', 'Checklist pre-vuelo antiansiedad'].map((item, i) => <li key={i} className="flex items-start gap-3 text-oceano font-medium text-sm md:text-base" data-id="element-164">
                    <CheckCircle2 size={20} className="text-caribe shrink-0 mt-0.5" data-id="element-165" />
                    <span data-id="element-166">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* 2. Oferta especial por tiempo limitado y compra */}
            <div className="flex flex-col items-center text-center bg-white p-6 md:p-10 rounded-3xl border-2 border-travertino/20 shadow-sm" data-id="element-167">
              <div className="bg-red-50 text-red-600 px-4 py-2 rounded-full text-xs md:text-sm font-bold mb-6 flex items-center gap-2 animate-pulse" data-id="element-168">
                <Clock size={16} data-id="element-169" />
                Oferta especial por tiempo limitado
              </div>

              <div className="mb-1" data-id="element-170">
                <span className="text-hierro line-through text-lg md:text-xl" data-id="element-171">
                  Precio anterior: $39.990
                </span>
              </div>
              <div className="mb-6" data-id="element-172">
                <span className="text-caribe font-bold text-5xl md:text-6xl" data-id="element-173">
                  $19.990
                </span>
              </div>

              <div className="w-full max-w-md space-y-4" data-id="element-174">
                <button onClick={buyNow} className="w-full bg-caribe hover:bg-[#24a8a2] text-polar py-4 md:py-5 rounded-xl font-bold text-lg md:text-xl transition-colors shadow-xl shadow-caribe/20" data-id="element-175">
                  QUIERO ACCEDER
                </button>

                <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-[11px] md:text-xs text-hierro font-medium pt-2" data-id="element-176">
                  <span className="flex items-center gap-1" data-id="element-177">
                    <ShieldCheck size={14} data-id="element-178" /> Pago seguro
                  </span>
                  <span className="flex items-center gap-1" data-id="element-179">
                    <Download size={14} data-id="element-180" /> Acceso inmediato
                  </span>
                  <span className="flex items-center gap-1" data-id="element-181">
                    <Smartphone size={14} data-id="element-182" /> 100% digital
                  </span>
                </div>
              </div>

              <p className="text-xs md:text-sm text-hierro mt-6 pt-6 border-t border-travertino/20" data-id="element-183">
                Recibís el acceso al contenido digital para empezar a usarlo
                antes de tu próximo vuelo.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 md:py-20 px-4 bg-[#F5F5F0]" data-id="element-184">
        <div className="max-w-3xl mx-auto" data-id="element-185">
          <h2 className="font-cormorant text-3xl md:text-5xl font-semibold text-oceano text-center mb-10" data-id="element-186">
            Preguntas frecuentes
          </h2>

          <div className="space-y-3" data-id="element-187">
            {FAQS.map((faq, i) => <div key={i} className="bg-white rounded-2xl border border-travertino/20 overflow-hidden" data-id="element-188">
                <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-189">
                  <span className="font-semibold text-oceano pr-4 text-base md:text-lg" data-id="element-190">
                    {faq.q}
                  </span>
                  <ChevronRight className={`text-caribe shrink-0 transition-transform ${openFaq === i ? 'rotate-90' : ''}`} size={20} data-id="element-191" />
                </button>
                {openFaq === i && <div className="px-5 pb-4 text-hierro text-sm md:text-base leading-relaxed" data-id="element-192">
                    {faq.a}
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* CIERRE FINAL */}

      {/* Footer */}
      <footer className="bg-oceano text-polar/60 py-12 px-4 text-sm text-center border-t border-polar/10" data-id="element-193">
        <div className="max-w-4xl mx-auto space-y-6" data-id="element-194">
          <div className="inline-block bg-polar rounded-2xl px-6 py-4 shadow-sm" data-id="element-195">
            <img src={IMAGES.logo} alt="Atlas de Viajes" className="h-14 md:h-16 mx-auto object-contain" data-id="element-196" />
          </div>
          <p className="leading-relaxed" data-id="element-197">
            Este producto es un recurso educativo y de acompañamiento. No
            reemplaza atención médica, psicológica ni tratamiento profesional.
            Si tu ansiedad es muy intensa, frecuente o limita tu vida diaria,
            recomendamos consultar con un profesional de salud mental.
          </p>
          <p className="pt-4 border-t border-polar/10" data-id="element-198">
            © {new Date().getFullYear()} Atlas de Viajes. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>
    </div>;
}